var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5H10C10.2761 5 10.5 5.22385 10.5 5.5V10.5C10.5 10.7761 10.2761 11 10 11H2C1.72386 11 1.5 10.7761 1.5 10.5V5.5C1.5 5.22385 1.72386 5 2 5H2.5V4.5C2.5 2.56701 4.06701 1 6 1C7.933 1 9.5 2.56701 9.5 4.5V5ZM2.5 6V10H9.5V6H2.5ZM5.5 7H6.5V9H5.5V7ZM8.5 5V4.5C8.5 3.11929 7.3807 2 6 2C4.61929 2 3.5 3.11929 3.5 4.5V5H8.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockWhite);
export default __webpack_public_path__ + "static/media/lock-white.ace1f64428270fd2e7a483c53169fedf.svg";
export { ForwardRef as ReactComponent };